// src/composables/useGlobalLoader.ts
import { useGlobalLoaderStore } from '@/stores/globalLoader.store';
import { storeToRefs } from 'pinia';

export function useGlobalLoader() {
    const store = useGlobalLoaderStore();
    const { isLoading } = storeToRefs(store);
    return {
        isLoading: isLoading,
        showLoader: store.show,
        hideLoader: store.hide,
    }
}